import React, {useEffect} from 'react'
import './style.css'
import {AiOutlineInstagram} from 'react-icons/ai'
import { FiLinkedin} from 'react-icons/fi'
// import {SiUpwork} from 'react-icons/si'
import AOS from 'aos'
import "aos/dist/aos.css";

function Footer() {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
      }, []);
    const today = new Date();
    const year = today.getFullYear();
  return (
    <div className='Footer pb-4 pt-5'>
        <div className="container-lg border-bottom-white pb-5">
            <div className="row g-5">
                <div className="col-md-4">
                    <div className="Footer__about" data-aos={"fade-right"} data-aos-duration={1200} data-aos-offset={80}>
                        <h5 className="Footer__about__heading pb-2">
                            Who am I?
                        </h5>
                        <p className="Footer__about__detail my-3" >
                            A Front-end Web Developer, React js Developer, UI Developer, Animation Expert
                        </p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="Footer__contact" data-aos={"fade-right"} data-aos-duration={1200} data-aos-offset={80}>
                        <h5 className="Footer__contact__heading pb-2">
                            Get in Touch
                        </h5>
                        <div className="Footer__contact__detail my-3 d-flex flex-column">
                            <a href="mailto:maryamrasheed687@gmail.com?subject=" subject="Client's Query" className='Footer__contact__detail__link'>
                               muhammadashirone@gmail.com</a>
                            <a href="https://www.linkedin.com/in/muhammad-ashir-153135235/" target='-blank' className='Footer__contact__detail__link'>
                               LinkedIn Profile</a>  
                        </div>
                    </div>
                </div>
                <div className="col-md-4 d-flex justify-content-start">
                    <div className="Footer__contact w-100" data-aos={"fade-right"} data-aos-duration={1200} data-aos-offset={80}>
                        <h5 className="Footer__contact__heading pb-2" >
                            Let's Start a Project!
                        </h5>
                        <div className="Footer__contact__detail my-3 d-flex flex-column">
                            <span className='Footer__contact__detail__link'>Discuss your project now!</span>     
                            <div className="Footer__contact__detail__button-container">
                            <a href="mailto:muhammadashirone@gmail.com?subject=" subject="Client's Query" className='Footer__contact__detail__button px-4 py-2 d-inline-block text-center mt-3 text-decoration-none'>
                                Start a Project</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container-lg Footer__bottom pt-2">
            <div className="row" data-aos={"fade-right"} data-aos-duration={1200} data-aos-offset={2}>
                <div className="col-sm-9">
                <div className="Footer__bottom__copyright text-sm-start text-center">
                    &copy; {year} ashircodes, All Rights Reserved
                 </div>
                </div>
                <div className="col-sm-3">
                    <div className="Footer__bottom__icons text-sm-end text-center ">
                        {/* <a rel="noreferrer" href="https://www.upwork.com/freelancers/~01f42d0c847e75228f?viewMode=1&s=1110580755057594368" target="_blank"><SiUpwork className='Footer__bottom__icons__item mx-2' /></a> */}
                        <a rel="noreferrer" href="https://www.instagram.com/ashircodes/" target="_blank"><AiOutlineInstagram className='Footer__bottom__icons__item mx-2' /></a>
                        <a rel="noreferrer" href="https://www.linkedin.com/in/muhammad-ashir-153135235/" target="_blank"><FiLinkedin className='Footer__bottom__icons__item ms-2' /></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer